import { Component, OnInit } from '@angular/core';
import {Popover} from 'bootstrap'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-info-toolbar',
  templateUrl: './info-toolbar.component.html',
  styleUrls: ['./info-toolbar.component.scss']
})
export class InfoToolbarComponent implements OnInit {
  faAngleDown = faAngleDown
  constructor() { }

  ngOnInit() {
    Array.from(document.querySelectorAll('a[data-bs-toggle="popover"]'))
    .forEach(popoverNode => new Popover(popoverNode))

  }

}
